import { render, staticRenderFns } from "./BaseChessTwo.vue?vue&type=template&id=2ed8a36e&scoped=true"
import script from "./BaseChessTwo.vue?vue&type=script&lang=js"
export * from "./BaseChessTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed8a36e",
  null
  
)

export default component.exports